// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const IntegrationsIcon = createSvgIcon(
  <svg width={24} height={24} fill="currentColor" viewBox="0 0 24 24">
    <path d="M16.36 13.24h-4.92V8.32a1.7 1.7 0 0 0-1.69-1.69H4.87a1.7 1.7 0 0 0-1.69 1.69v11.49a1.7 1.7 0 0 0 1.69 1.69h11.49a1.7 1.7 0 0 0 1.69-1.69v-4.88a1.7 1.7 0 0 0-1.69-1.69M4.87 8h4.88a.3.3 0 0 1 .32.32v4.92H4.55V8.32A.3.3 0 0 1 4.87 8m0 12.13a.3.3 0 0 1-.32-.32v-4.88a.3.3 0 0 1 .32-.32h5.2v5.2a.3.3 0 0 1-.32.32zm11.81-.32a.3.3 0 0 1-.32.32h-4.95v-5.5200000000000005h4.92a.3.3 0 0 1 .32.32zM18.05 2.5a4.13 4.13 0 1 0 0 8.26 4.13 4.13 0 0 0 0-8.26m0 6.89a2.76 2.76 0 1 1 0-5.52 2.76 2.76 0 0 1 0 5.52" />
  </svg>,
  "Integrations",
);
export default IntegrationsIcon;
